import { Box, Typography } from "@mui/material";

const tabs = [
  {
    key: "all",
    label: "Pipeline",
  },
  {
    key: "acquisitions",
    label: "Acquisitions",
  },
  {
    key: "projects",
    label: "Projects",
  },
  {
    key: "dispositions",
    label: "Dispositions",
  },
];

const PipelineTabs = ({
  activeStage,
  onStageChange,
  stageCounts,
}) => {
  return (
    <Box
      sx={{
        height: "40px",
        display: "flex",
        alignItems: "center",
        gap: "4px",
        padding: "1px",
        borderRadius: "4px",
        backgroundColor: "#E7F0E2",
        border:'1px solid #E7F0E2',
        width: "fit-content",
      }}
    >
      {tabs.map((tab) => {
        const isActive = activeStage === tab.key;

        return (
          <Box
            key={tab.key}
            onClick={() => onStageChange(tab.key)}
            sx={{
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              px: "12px",
              borderRadius: "5px",
              cursor: "pointer",
              transition: "all 0.2s ease",
              backgroundColor: isActive
                ? "#FFFFFF"
                : "#E7F0E2",
              boxShadow: isActive
                ? "0px 2px 10px rgba(0,0,0,0.06)"
                : "none",
            }}
          >
            <Typography
              sx={{
                display: "flex",
                alignItems: "center",
                gap: "4px",
                fontSize: "13px",
                fontWeight: 600,
                lineHeight: 1,
                whiteSpace: "nowrap",
                color: isActive
                  ? "#17270D"
                  : "#646262",
              }}
            >
              {tab.label}

              <Box
                component="span"
                sx={{
                  color: isActive
                    ? "#4CBC18"
                    : "#646262",
                }}
              >
                {stageCounts?.[tab.key] ?? 0}
              </Box>
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default PipelineTabs;